// PWA registration & install prompt helpers
let deferredPrompt = null;
const listeners = new Set();

function emit() {
  listeners.forEach((cb) => {
    try { cb({ canInstall: !!deferredPrompt }); } catch (_err) { /* noop */ }
  });
}

export function subscribeInstall(cb) {
  listeners.add(cb);
  cb({ canInstall: !!deferredPrompt });
  return () => listeners.delete(cb);
}

export async function promptInstall() {
  if (!deferredPrompt) return { outcome: "unavailable" };
  const promptEvent = deferredPrompt;
  deferredPrompt = null;
  emit();
  promptEvent.prompt();
  const choice = await promptEvent.userChoice;
  return choice;
}

export function registerPWA() {
  if (typeof window === "undefined") return;

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    emit();
  });

  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    emit();
  });

  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js", { scope: "/" })
        .then((reg) => {
          // Buscar nueva versión al cargar y cada 15 min; al activarse, recargar una vez.
          reg.update().catch(() => {});
          setInterval(() => reg.update().catch(() => {}), 15 * 60 * 1000);
          reg.addEventListener("updatefound", () => {
            const nw = reg.installing;
            nw?.addEventListener("statechange", () => {
              if (nw.state === "installed" && navigator.serviceWorker.controller) nw.postMessage("SKIP_WAITING");
            });
          });
        })
        .catch((err) => {
          console.warn("SW registration failed:", err);
        });
      // No se fuerza reload automático (provocaba recargas en medio del login);
      // la versión nueva toma control y se usa en la siguiente navegación/apertura.
    });
  }
}
